import React from "react";
import Header from "../../Components/Header";
import Feature from "../../Components/Feature";
import Footer from "../../Components/Footer";
import UserLeftSidebar from "../Components/UserLeftSidebar";
import ProfileRight from "../Layouts/ProfileRight";



export default function Profile() {
  return (
    <div>
      <Header mode="dark" />

      <div className="container-fluid">
        <div className="dashboard-full-page">
      
      <UserLeftSidebar />

      <ProfileRight />

       </div>
      </div>


      <Feature />
      <Footer />
    </div>
  );
}

